<template>
  <q-dialog v-model="openSync" @hide="cleanup">
    <q-card style="width: 45rem; max-width: 80vw">
      <q-card-section>
        <h6>Responses</h6>
      </q-card-section>

      <q-card-section>
        <DataTable :columns="columns">
          <tr v-if="!request.responses.length">
            <td class="text-center" :colspan="columns.length">There are no quotes for this request.</td>
          </tr>

          <tr v-for="res in request.responses" v-else :key="res.id">
            <td>
              <span class="cursor-pointer text-primary" @click="selectResponse(res.id)">
                {{ res.id | formatId }}
              </span>
            </td>

            <td class="text-uppercase">
              {{ res.company.tradingName }}
            </td>

            <td class="text-center">{{ res.totalAud | formatCurrency }}</td>

            <td v-if="res.deletedAt">
              <span>
                Cancelled
                <q-tooltip> Cancelled: {{ res.deletedAt | formatDateTime }} </q-tooltip>
              </span>
            </td>
            <td v-else>{{ res.quoteValidity | formatDate }}</td>

            <td>{{ res.createdAt | formatDateTime }}</td>
          </tr>
        </DataTable>
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script>
import DataTable from '@/components/DataTableNew.vue';
import formatDateTime from '@/utils/mixins/formatDateMixin';

export default {
  components: {
    DataTable,
  },
  mixins: [formatDateTime],

  props: {
    open: {
      required: true,
      type: Boolean,
    },
    request: {
      required: true,
      validator: (value) => typeof value === 'object' || value === null,
    },
    responseId: {
      required: false,
      type: String,
      default: null,
    },
  },

  data() {
    return {
      columns: ['Quote ID', 'Transporter', 'Price', 'Validity', 'Sent Date'],
    };
  },

  computed: {
    openSync: {
      get() {
        return this.open;
      },
      set(val) {
        return this.$emit('update:open', val);
      },
    },
  },

  methods: {
    cleanup() {
      this.$emit('update:request', null);
    },
    selectResponse(id) {
      this.$emit('update:responseId', id);
      this.$emit('select');
    },
  },
};
</script>
